import { Notification as SnackBarNotification } from '@progress/kendo-react-notification';
import React, { useCallback, useLayoutEffect, useState } from 'react';
import debounce from 'lodash/debounce';

const ANCHOR_ELEMENT = '.layout_container';

interface Props {
  snackbar: React.ReactNode;
}

export default function ContentCenteredSnackbar({ snackbar }: Props) {
  const [left, setLeft] = useState(0);

  const updatePosition = useCallback(() => {
    const siteContentElement = document.querySelector(ANCHOR_ELEMENT);
    if (siteContentElement) {
      const rect = siteContentElement.getBoundingClientRect();
      setLeft(rect.left + rect.width / 2);
    }
  }, []);

  const debouncedUpdatePosition = useCallback(debounce(updatePosition, 100), [
    updatePosition,
  ]);

  useLayoutEffect(() => {
    updatePosition();

    window.addEventListener('resize', debouncedUpdatePosition);
    return () => {
      window.removeEventListener('resize', debouncedUpdatePosition);
      debouncedUpdatePosition.cancel();
    };
  }, [debouncedUpdatePosition]);

  return (
    <SnackBarNotification
      className="alert snackbar"
      style={{
        position: 'fixed',
        left,
        transform: 'translateX(-50%)',
      }}
    >
      {snackbar}
    </SnackBarNotification>
  );
}
